import { getCurrencySymbol } from "@features/helpers";

export const CHALLENGE_100K_V6_PAYWALL_STEP = 31;
export const CHALLENGE_100K_V6_DISCOUNT_PAYWALL_STEP = 32;

export const challenge100kV6Ids = [
    "0aa5d5c6-b4f9-485a-8d2f-43c8692dda59",
    "c20b5b52-87fb-41ee-b47a-8cf338bdf1fa",
    "1b2451d8-d075-434f-8abc-90cbe4298f87"
];

export const challenge100kV6WithDiscountIds = [
    "5cddc96c-f1fb-4fa3-b657-172310c57457",
    "92ea3dea-df8d-46a7-8166-43e5fd878b57",
    "017956d5-214c-4f20-bc5e-837f8cfca871"
];

// moved to data/paywall/renew.ts

export const getPaymentInfo100kV6 = (
    id: string,
    currency: string,
    priceBefore: number,
    priceAfter: number,
    buttonText: string
) => {
    const currencySymbol = getCurrencySymbol(currency);
    const formatPriceBefore = (priceBefore / 100).toFixed(2);
    const formatPriceAfter = (priceAfter / 100).toFixed(2);
    switch (id) {
        case "0aa5d5c6-b4f9-485a-8d2f-43c8692dda59":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 1-month period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 1 month and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "c20b5b52-87fb-41ee-b47a-8cf338bdf1fa":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 3-month period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 3 months and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "1b2451d8-d075-434f-8abc-90cbe4298f87":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 1-year period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 1 year and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "5cddc96c-f1fb-4fa3-b657-172310c57457":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 1-month period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 1 month and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "92ea3dea-df8d-46a7-8166-43e5fd878b57":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 3-month period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 3 months and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "017956d5-214c-4f20-bc5e-837f8cfca871":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 1-year period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 1 year and additional purchases made through your account. You can cancel anytime in your account settings.`;
    }
};

export const paywall100kV6Feedbacks = [
    {
        author: "@starter_jess",
        comment:
            "The content is super clear and beginner-friendly. It covers exactly what you need to get started with AI no fluff, just value. Perfect if you're just stepping into this world."
    },
    {
        author: "@echsavvy_omar",
        comment:
            "Tixu.ai provides a huge variety of tools and interactive lessons that break down complex AI concepts into something anyone can grasp. It’s a fresh and modern way to learn AI — props to the creators!"
    },
    {
        author: "@growwithzoe",
        comment:
            "Tixu.ai helped me level up faster than I expected. The personalized approach and easy-to-follow lessons made learning smooth and impactful. I now feel more confident and focused on my next career goals."
    }
];

export const paywall100kV6Benefits_old = [
    "Learn to create and sell with AI — from art to chatbots",
    "Discover AI tools that save time and make money",
    "Launch AI-powered projects in just 28 days"
];

export const paywall100kV6Benefits = [
    [
        "Learn to ",
        { text: "create", highlight: true },
        " and ",
        { text: "sell", highlight: true },
        " with AI — from art to chatbots"
    ],
    [
        "Discover AI tools that ",
        { text: "save time", highlight: true },
        " and ",
        { text: "make money", highlight: true }
    ],
    ["Launch AI-powered projects ", { text: "in just 28 days", highlight: true }]
];

export const screenShotes100kV6 = [
    "/images/onboarding/png/paywall/screen-1.png",
    "/images/onboarding/png/paywall/screen-2.png",
    "/images/onboarding/png/paywall/screen-3.png"
];
